import React, { ReactNode } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import Row from 'src/components/Row';
import './RoomAccordionList.scss';

interface RoomAccordionListProps {
  rooms: any[];
  expandedRoom: string;
  onToggleRoom: (room: any) => void;
  onDeleteRoom?: (room: any) => void;
  renderRoomContent: (room: any) => ReactNode;
}

const RoomAccordionList = ({
  rooms,
  expandedRoom,
  onToggleRoom,
  onDeleteRoom,
  renderRoomContent,
}: RoomAccordionListProps) => {
  return (
    <>
      {rooms.map((room: any) => (
        <div key={room.name} className="room-accordion-item">
          <div
            className="room-accordion-header"
            onClick={() => onToggleRoom(room)}
          >
            <span className="service-request-from-asset__title room-accordion-header__label">
              {room.customLabel ? room.customLabel : room.name}
            </span>
            <div className="room-accordion-header__actions">
              <FontAwesomeIcon
                glyph={expandedRoom === room.name ? 'chevron-up' : 'chevron-down'}
                weight="regular"
              />
              {onDeleteRoom && (
                <div
                  className="room-accordion-header__delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteRoom(room);
                  }}
                >
                  <FontAwesomeIcon glyph="trash" weight="light" />
                </div>
              )}
            </div>
          </div>
          <Row style={{ marginLeft: '0px', marginRight: '0px' }}>
            {renderRoomContent(room)}
          </Row>
        </div>
      ))}
    </>
  );
};

export default RoomAccordionList;
